import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<BbField @label={{t \'reminder\'}}>\n  {{#each @item.reminders as |reminder|}}\n    {{#if reminder.id}}\n      {{#if @isEditable}}\n        <div class=\'grid-x grid-padding-x\'>\n          <div class=\'cell shrink\'>\n            <div role=\'button\' class=\'link-button\' {{on \'click\' (fn this.removeReminder reminder)}}>\n              <FaIcon @icon=\'trash-alt\' role=\'presentation\' />\n            </div>\n          </div>\n          {{#if reminder.automatic}}\n            <div class=\'cell shrink\'>\n              {{t \'automatic reminder\'}} {{reminder.send_type}} {{reminder.status_name}} {{reminder.send_when_number}}\n              {{reminder.send_when_unit}}\n            </div>\n          {{else}}\n            <div class=\'cell shrink\'>\n              <div class=\'fix-position-relative\'>\n                <div class=\'button flat\' data-toggle=\'sTo-{{reminder.id}}{{reminder.rand_id}}\'>\n                  <FaIcon @icon=\'chevron-down\' />\n                  {{reminder.send_to}}\n                </div>\n                <BbDropdown @id=\'sTo-{{reminder.id}}{{reminder.rand_id}}\'>\n                  <ul class=\'menu vertical text-left\'>\n                    {{#each @item.contacts as |user|}}\n                      <li>\n                        <a {{on \'click\' (fn this.setSendTo reminder user)}}>\n                          {{user.label}}\n                        </a>\n                      </li>\n                    {{/each}}\n                  </ul>\n                </BbDropdown>\n              </div>\n            </div>\n            <div class=\'cell shrink\'>\n              <div class=\'fix-position-relative\'>\n                <div class=\'button flat\' data-toggle=\'sType-{{reminder.id}}{{reminder.rand_id}}\'>\n                  <FaIcon @icon=\'chevron-down\' />\n                  {{reminder.send_type}}\n                </div>\n                <BbDropdown @id=\'sType-{{reminder.id}}{{reminder.rand_id}}\'>\n                  <ul class=\'menu vertical text-left\'>\n                    <li>\n                      <a {{on \'click\' (fn this.setSendType reminder \'mail\')}}>\n                        {{t \'mail\'}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setSendType reminder \'push\')}}>\n                        {{t \'push\'}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setSendType reminder \'sms\')}}>\n                        {{t \'sms\'}}\n                      </a>\n                    </li>\n                  </ul>\n                </BbDropdown>\n              </div>\n            </div>\n            <div class=\'cell shrink\'>\n              <div class=\'fix-position-relative\'>\n                <div class=\'button flat\' data-toggle=\'sWhen-{{reminder.id}}{{reminder.rand_id}}\'>\n                  <FaIcon @icon=\'chevron-down\' />\n                  {{reminder.send_when_number}}\n                </div>\n                <BbDropdown @id=\'sWhen-{{reminder.id}}{{reminder.rand_id}}\'>\n                  <ul class=\'menu vertical text-left\'>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenNumber reminder 1)}}>\n                        {{t \'white-wrap\' wrap=1}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenNumber reminder 3)}}>\n                        {{t \'white-wrap\' wrap=3}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenNumber reminder 5)}}>\n                        {{t \'white-wrap\' wrap=5}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenNumber reminder 10)}}>\n                        {{t \'white-wrap\' wrap=10}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenNumber reminder 30)}}>\n                        {{t \'white-wrap\' wrap=30}}\n                      </a>\n                    </li>\n                  </ul>\n                </BbDropdown>\n              </div>\n            </div>\n            <div class=\'cell shrink\'>\n              <div class=\'fix-position-relative\'>\n                <div class=\'button flat\' data-toggle=\'sWhenU-{{reminder.id}}{{reminder.rand_id}}\'>\n                  <FaIcon @icon=\'chevron-down\' />\n                  {{reminder.send_when_unit}}\n                </div>\n                <BbDropdown @id=\'sWhenU-{{reminder.id}}{{reminder.rand_id}}\'>\n                  <ul class=\'menu vertical text-left\'>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenUnit reminder \'minuti\')}}>\n                        {{t \'minute\' count=2}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenUnit reminder \'ore\')}}>\n                        {{t \'hour\' count=2}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenUnit reminder \'giorni\')}}>\n                        {{t \'day\' count=2}}\n                      </a>\n                    </li>\n                    <li>\n                      <a {{on \'click\' (fn this.setWhenUnit reminder \'settimane\')}}>\n                        {{t \'week\' count=2}}\n                      </a>\n                    </li>\n                  </ul>\n                </BbDropdown>\n              </div>\n            </div>\n          {{/if}}\n        </div>\n      {{else}}\n        <div class=\'grid-x grid-padding-x\'>\n          <div class=\'cell text-upp\'>\n            {{#if reminder.automatic}}\n              {{t \'automatic\'}}\n            {{/if}}\n            {{reminder.send_type}}\n            {{reminder.status_name}}\n            {{reminder.send_to}}\n            {{reminder.send_when_number}}\n            {{reminder.send_when_unit}}\n          </div>\n        </div>\n      {{/if}}\n    {{/if}}\n  {{else}}\n    <p>\n      <small>\n        {{t \'no reminder sheduled\'}}\n      </small>\n    </p>\n  {{/each}}\n\n  {{#if @isEditable}}\n    <div class=\'button-group expanded\'>\n      <a {{on \'click\' this.newReminder}} class=\'button\'>\n        {{t \'add reminder\'}}\n      </a>\n    </div>\n  {{/if}}\n</BbField>\n");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
let BbReminderBoardComponent = (_class = class BbReminderBoardComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "notify", _descriptor2, this);
    _initializerDefineProperty(this, "store", _descriptor3, this);
    _initializerDefineProperty(this, "session", _descriptor4, this);
    // Local mutable state (was Classic plain field mutated by set())
    _initializerDefineProperty(this, "addCounter", _descriptor5, this);
  }
  get reminder_number() {
    return this.args.item.reminders?.length || 0;
  }
  newReminder() {
    var tmpReminder = this.store.createRecord('reminder', {
      send_to: this.session.me.name,
      send_to_id: this.session.me.id,
      send_to_mail: this.session.me.mail,
      send_to_mobile: this.session.me.mobile,
      send_from: this.session.me.name,
      send_from_id: this.session.me.id,
      send_from_mail: this.session.me.mail,
      send_when_number: 1,
      send_when_unit: 'giorni',
      send_type: 'mail',
      event: this.args.isEvent ? this.args.item : null,
      todo: !this.args.isEvent ? this.args.item : null,
      _id: this.addCounter + 1
    });
    this.addCounter = this.addCounter + 1;
    this.args.item.reminders.push(tmpReminder);
    this._saveReminders();
  }
  removeReminder(reminder) {
    const reminders = this.args.item.reminders;
    const _i = reminders.indexOf(reminder);
    if (_i !== -1) {
      reminders.splice(_i, 1);
    }
    if (reminder.id) {
      this.args.applicationController.destroyRecord(reminder);
    }
  }
  setSendTo(reminder, user) {
    if (reminder.send_type === 'sms') {
      if (!user.mobile || user.mobile === '') {
        this.notify.warning(this.intl.t('empty mobile'));
        return false;
      }
    } else {
      if (!user.mail || user.mail === '') {
        this.notify.warning(this.intl.t('empty mail'));
        return false;
      }
    }
    reminder.setProperties({
      send_to: user.name,
      send_to_id: user.id,
      send_to_mail: user.mail,
      send_to_mobile: user.mobile,
      isActivePreferences: false
    });
    this._closeDropdown(`sTo-${reminder.id}${reminder.rand_id}`);
    this._saveReminders();
  }
  setWhenNumber(reminder, number) {
    reminder.setProperties({
      send_when_number: number,
      isActiveWhenNumber: false
    });
    this._closeDropdown(`sWhen-${reminder.id}${reminder.rand_id}`);
    this._saveReminders();
  }
  setWhenUnit(reminder, unit) {
    reminder.setProperties({
      send_when_unit: unit,
      isActiveWhenUnit: false
    });
    this._closeDropdown(`sWhenU-${reminder.id}${reminder.rand_id}`);
    this._saveReminders();
  }
  setSendType(reminder, type) {
    reminder.setProperties({
      send_type: type,
      isActiveSendType: false
    });
    this._closeDropdown(`sType-${reminder.id}${reminder.rand_id}`);
    this._saveReminders();
  }

  /**
   * Closes a ZfDropdown via the DOM by its element id.
   * Il pattern @zfUi={{this.x}} non funziona (ZfDropdown fa set sull'arg e non
   * scrive indietro: this.zfSelectX resta undefined e .close() è un no-op).
   * Chiudiamo via DOM con lo stesso id passato a @id / data-toggle.
   * @method _closeDropdown
   * @param {string} id
   */
  _closeDropdown(id) {
    const el = id && document.getElementById(id);
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    if (!document.querySelector('.data-dropdown.is-open')) {
      document.body.classList.remove('dropdown-open');
    }
  }

  /**
   * @method _saveReminders
   */
  _saveReminders() {
    var promises = [],
      self = this;
    this.args.item.reminders.forEach(function (reminder) {
      promises.push(self.args.applicationController.saveRecord(reminder, false));
    });
    this.args.applicationController.saveAllRecord(promises);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "notify", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "addCounter", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "newReminder", [action], Object.getOwnPropertyDescriptor(_class.prototype, "newReminder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeReminder", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeReminder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSendTo", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSendTo"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setWhenNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setWhenNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setWhenUnit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setWhenUnit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSendType", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSendType"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbReminderBoardComponent);

export { BbReminderBoardComponent as default };
//# sourceMappingURL=bb-reminder-board.js.map
